import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { TourService, TourStep } from '../../services/tour.service';
import { TourConfigService } from '../../services/tour-config.service';
import { DynamicTourService } from '../../services/dynamic-tour.service';
import { UserSettingsService } from '../../services/user-settings.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../stores/states/app.state';
import * as UserActions from '../../stores/actions/user.actions';

@Component({
  selector: 'app-sliding-tour-panel',
  templateUrl: './sliding-tour-panel.component.html',
  styleUrls: ['./sliding-tour-panel.component.scss']
})
export class SlidingTourPanelComponent implements OnInit, OnDestroy {
  @Input() tourSteps: TourStep[] = [];
  @Input() currentUser: any = null;
  @Input() tourTitle: string = 'News Feed Tour';
  @Input() tourIcon: string = 'help-circle';
  @Input() panelId: string = 'default-tour-panel';
  @Input() showResetOption: boolean = true;

  isPanelOpen = false;
  isPermanentlyHidden = false;

  constructor(
    private tourService: TourService,
    private tourConfigService: TourConfigService,
    private dynamicTourService: DynamicTourService,
    private userSettingsService: UserSettingsService,
    private store: Store<AppState>
  ) { }

  ngOnInit(): void {

    this.isPermanentlyHidden = localStorage.getItem(`${this.panelId}-hidden`) === 'true';


    if (!this.tourSteps.length) {
      this.tourTitle = this.dynamicTourService.getTourTitleForCurrentRoute();
      this.tourIcon = this.dynamicTourService.getTourIconForCurrentRoute();
    }
  }

  ngOnDestroy(): void {

  }

  togglePanel(): void {
    this.isPanelOpen = !this.isPanelOpen;
  }

  hidePanelPermanently(): void {
    this.isPermanentlyHidden = true;
    this.isPanelOpen = false;
    localStorage.setItem(`${this.panelId}-hidden`, 'true');
  }

  showPanel(): void {
    this.isPermanentlyHidden = false;
    localStorage.removeItem(`${this.panelId}-hidden`);
  }

  startTour(): void {
    if (this.tourSteps.length > 0) {
      this.tourService.initTour(this.tourSteps);
      this.tourService.start();
    } else {
      const tourSteps = this.dynamicTourService.getTourStepsForCurrentRoute();
      this.tourService.initTour(tourSteps);
      this.tourService.start();
    }
  }


  hasSeenTour(): boolean {
    return this.currentUser?.settings?.showTourOnFirstVisit === false;
  }

  async resetTourSetting(): Promise<void> {
    try {
      const userSettings = this.currentUser?.settings || {};
      await this.userSettingsService.save({
        ...userSettings,
        showTourOnFirstVisit: true,
      });


      this.store.dispatch(UserActions.updateUserSettings({
        settings: { ...userSettings, showTourOnFirstVisit: true }
      }));

      this.currentUser = {
        ...this.currentUser,
        settings: { ...userSettings, showTourOnFirstVisit: true }
      };
    } catch (error) {
      console.error('Error resetting tour setting:', error);
    }
  }
}
